import { render } from "./changeSetMealModel.vue?vue&type=template&id=1ec2ecd5"
import script from "./changeSetMealModel.vue?vue&type=script&lang=js"
export * from "./changeSetMealModel.vue?vue&type=script&lang=js"

import "./changeSetMealModel.vue?vue&type=style&index=0&id=1ec2ecd5&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__